import { createFileRoute } from '@tanstack/react-router';
import OnboardingVerification from '@/features/account/onboarding/verification';

export const Route = createFileRoute('/onboarding/verificacao')({
  component: OnboardingVerification,
});
